import history from 'bz-utilities/modules/networking/history/rr4';
import QueryString from 'query-string';

// Server-side endpoints that are valid post-login targets. These are not SPA routes, so they
// need a full page navigation rather than a client-side history push.
const serverRedirectTargets = /^\/api\/zoom\/authorisationRedirect(\?|$)/;

export function isServerRedirectTarget(redirectTo: string): boolean {
  return serverRedirectTargets.test(redirectTo);
}

/**
 * Navigates to the `redirectTo` query-string value (or `/` when absent) after a successful login.
 * Allow-listed API endpoints get a full navigation; everything else is a normal SPA route.
 */
export function navigateToRedirectTarget(): void {
  const { redirectTo } = QueryString.parse(window.location.search);
  if (!redirectTo) {
    history.push('/');
    return;
  }

  const target = String(redirectTo);
  if (isServerRedirectTarget(target)) {
    window.location.assign(target);
    return;
  }

  history.push(target);
}

/**
 * Resumes a server-side flow (e.g. the Zoom OAuth callback) when an already-authenticated user
 * lands on the login page with an allow-listed, URL-encoded `redirectTo`. Returns true when a
 * full-page navigation was started.
 */
export function resumeServerRedirect(isAuthenticated: boolean): boolean {
  if (!isAuthenticated) return false;
  if (!['/login', '/'].includes(window.location.pathname)) return false;

  const { redirectTo } = QueryString.parse(window.location.search);
  if (!redirectTo) return false;

  const target = String(redirectTo);
  if (!isServerRedirectTarget(target)) return false;

  window.location.assign(target);
  return true;
}
